import React from "react";
import { IHtmlHighlight } from "../../../typings/annotate/annotation";

interface ICommentContext {
  selectedThread?: string;
  selectThread: (thread: string) => void;
  showComments: (h: IHtmlHighlight) => void;
  showNotes: (h: IHtmlHighlight) => void;
  contentRef?: HTMLDivElement | null;
}
export const CommentContext = React.createContext<ICommentContext>({
  selectThread: () => {},
  showComments: () => {},
  showNotes: () => {},
});

export default function useCommentContext() {
  return React.useContext(CommentContext);
}
